export class ProjectOptionDefIds {
  public static readonly REMARK_ID: string = '3';

  public static readonly CREATED_BY: string = '81';
  public static readonly CUSTOM_MATERIAL_NUMBER: string = '87';
  public static readonly CUSTOMER_NUMBER: string = '89';

  public static readonly PROJECT_VERSION: string = '0';
  public static readonly PRODUCTION_PLANT: string = '150';
  public static readonly CO_NUMBER: string = '151';
  public static readonly STOCK_SEPARATION: string = '152';

  public static readonly SPECIAL_PROJECT_OPTIONS: string[] = [ProjectOptionDefIds.PRODUCTION_PLANT, ProjectOptionDefIds.CO_NUMBER,
    ProjectOptionDefIds.STOCK_SEPARATION
  ];
}

export class ConfigurationGroupOptionDefIds {
  public static readonly PROJECT_NUMBER: string = '2';
  public static readonly REVISION_INDEX: string = '7';
}
